<template>
  <div>
    <v-layout>
      <v-flex class="input-label" xs2>送信頻度</v-flex>
      <v-flex xs10>
        <v-select
          v-model="sendIntervalText"
          :items="sendIntervalTextItems"
          :isStartDateLimit="true"
          :disabled="disabled"
          class="select-box"
          menu-props="auto"
          hide-details
          single-line
          dense
        />
        <span style="margin-left: 10px">午前9〜10時頃</span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="input-label" xs2>メール送信有効期限</v-flex>
      <v-flex xs10>
        <AppDatePicker
          @inputDate="inputClosingDate"
          :date="form.notification.closingDate"
          :disabled="disabled"
          class="closing-date-text"
        />
        <span style="margin-left: 10px">まで送信し続ける</span>
        <span class="red--text">
          ※ 案件の配信期間外はメールは送られません。
        </span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="input-label" xs2>
        <div>送信先アドレス（必須）</div>
        <small v-if="!isValidEmails" class="red--text">
          正しい形式で入力してください。
        </small>
      </v-flex>
      <v-flex xs10>
        <AddableTextField
          v-model="form.notification.emails"
          :emailAddresses="form.notification.emails"
          @inputText="inputEmail($event)"
          :disabled="disabled"
          class="emails-text"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AddableTextField from '@/components/Shared/CrudUI/AddableTextField'
import { SendInterval } from '@/models/Report/IntervalReport'
import { mapGetters } from 'vuex'

const sendIntervalItems = [
  { value: SendInterval.DAILY, text: '毎日' },
  { value: SendInterval.WEEKLY, text: '毎週月曜日' },
  { value: SendInterval.MONTHLY, text: '毎月1日' },
]

export default {
  name: 'IntervalReportRequestModalAdd',
  components: {
    AddableTextField,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      emailAddresses: [],
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiser']),
    sendIntervalTextItems() {
      return sendIntervalItems.map(item => item.text)
    },
    sendIntervalText: {
      get() {
        return this.getItemText(
          sendIntervalItems,
          this.form.notification.sendInterval,
        )
      },
      set(text) {
        this.form.notification.sendInterval = this.getItemValue(
          sendIntervalItems,
          text,
        )
      },
    },
    isValidEmails() {
      if (this.form.notification.emails.length === 0) {
        return true
      }
      return this.form.notification.isValidEmails()
    },
    disabled() {
      return !this.form.isIntervalMailActive()
    },
  },
  methods: {
    inputEmail(event) {
      this.form.notification.emails.splice(event.index, 1, event.text)
    },
    getItemValue(items, text) {
      return items.find(item => item.text === text).value
    },
    getItemText(items, value) {
      return items.find(item => item.value === value).text
    },
    inputClosingDate(date) {
      this.form.notification.closingDate = date
    },
  },
}
</script>

<style scoped>
.v-input .v-text-field {
  padding: 0;
  margin: 14px 0;
}
.input-label {
  padding-top: 20px;
  color: #616161 !important;
  caret-color: #616161 !important;
}
.emails-text {
  width: 350px;
}
.select-box {
  max-width: 140px;
  display: inline-block;
}
.closing-date-text {
  width: 140px;
  display: inline-block;
}
</style>
